var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { alertErrorHandler } from "@spike/notifications-action";
import Axios from "axios";
import { showSuccess } from "@spike/notifications-action";
import { TERMINALS_RESET_ACTION_TYPE, TERMINALS_GET_START_ACTION_TYPE, TERMINALS_GET_SUCCESS_ACTION_TYPE, TERMINALS_FETCH_START_ACTION_TYPE, TERMINALS_FETCH_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_FETCH_START_ACTION_TYPE, TERMINALS_ORDER_FETCH_SUCCESS_ACTION_TYPE, TERMINALS_SAVE_START_ACTION_TYPE, TERMINALS_SAVE_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_CANCEL_START_ACTION_TYPE, TERMINALS_ORDER_CANCEL_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_DELETE_START_ACTION_TYPE, TERMINALS_ORDER_DELETE_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_SAVE_START_ACTION_TYPE, TERMINALS_ORDER_SAVE_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_COMPLETE_START_ACTION_TYPE, TERMINALS_ORDER_COMPLETE_SUCCESS_ACTION_TYPE, TERMINALS_CHECK_STATUS_START_ACTION_TYPE, TERMINALS_CHECK_STATUS_SUCCESS_ACTION_TYPE, TERMINALS_CHANGE_STATUS_ORDER_START_ACTION_TYPE, TERMINALS_CHANGE_STATUS_ORDER_SUCCESS_ACTION_TYPE, TERMINALS_ERROR_ACTION_TYPE, } from "./TerminalsActionsTypes";
import { convertToTerminal, convertToTerminalOrder, convertToTerminalToDto, convertToTerminalStatus } from "./TerminalsConverter";
var orderUrl = "/terminal_order";
var ordersUrl = "/terminal_orders";
var terminalsUrl = "/terminals";
var terminalUrl = "/terminal";
export var resetThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var getTerminalThunk = function (apiClinetWrapper, id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getTerminalStart());
                    marketplaceId = apiClinetWrapper.marketplaceId;
                    url = "".concat(terminalsUrl, "/").concat(id, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClinetWrapper.apiClient.get(url, apiClinetWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getTerminalSuccess(convertToTerminal(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, "Error getting terminal.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveTerminalOrderThunk = function (apiClientWrapper, terminalOrder) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiMethod, requestBody, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveTerminalOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = terminalOrder.id
                        ? "".concat(ordersUrl, "/").concat(terminalOrder.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(ordersUrl, "?marketplace_id=").concat(marketplaceId);
                    apiMethod = terminalOrder.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    requestBody = {
                        id: terminalOrder.id,
                        uuid: terminalOrder.uuid,
                        marketplace_id: marketplaceId,
                        status: terminalOrder.status,
                        price: terminalOrder.price,
                        delivery_address: terminalOrder.deliveryAddress,
                        delivery_suite: terminalOrder.deliverySuite,
                        delivery_city: terminalOrder.deliveryCity,
                        delivery_state: terminalOrder.deliveryState,
                        delivery_zipcode: terminalOrder.deliveryZipcode,
                        delivery_country: terminalOrder.deliveryCountry,
                        delivery_name: terminalOrder.deliveryName,
                        delivery_phone: terminalOrder.deliveryPhone,
                        terminals_attributes: convertToTerminalToDto(apiClientWrapper.uuid, terminalOrder.terminals),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiMethod(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveTerminalOrderSuccess(convertToTerminalOrder(response.data)));
                    dispatch(showSuccess("Order save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        terminalOrder.id ?
                            alertErrorHandler(apiError_2, dispatch, "Error saving Order.") :
                            alertErrorHandler(apiError_2, dispatch, "Error creating a new Order.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var completeTerminalOrderThunk = function (apiClientWrapper, terminalOrderId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(completeTerminalOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(orderUrl, "/complete/").concat(terminalOrderId, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        id: terminalOrderId,
                        marketplace_id: marketplaceId,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(completeTerminalOrderSuccess(convertToTerminalOrder(response.data)));
                    dispatch(showSuccess("Order complete successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        alertErrorHandler(apiError_3, dispatch, "Error completing Order.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeStatusOrder = function (apiClientWrapper, orderId, status) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeStatusOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl, "/").concat(orderId, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        status: status,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeStatusOrderSuccess(convertToTerminalOrder(response.data)));
                    dispatch(showSuccess("Order status change successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        alertErrorHandler(apiError_4, dispatch, "Error updating Order.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var cancelTerminalOrderThunk = function (apiClientWrapper, orderId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(cancelTerminalOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl, "/").concat(orderId, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        status: "cancelled",
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(cancelTerminalOrderSuccess(convertToTerminalOrder(response.data)));
                    dispatch(showSuccess("Order cancelled successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        alertErrorHandler(apiError_5, dispatch, "Error cancelling Order.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteOrderThunk = function (apiClientWrapper, orderId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl, "/").concat(orderId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(deleteOrderSuccess(convertToTerminalOrder(response.data)));
                    dispatch(showSuccess("Order deleted successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        alertErrorHandler(apiError_6, dispatch, "Error deleting Order.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveTerminalThunk = function (apiClientWrapper, terminal) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, marketplaceId, url, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveTerminalStart());
                    formData = new FormData();
                    marketplaceId = apiClientWrapper.marketplaceId;
                    formData.append("terminal[name]", terminal.name);
                    formData.append("terminal[active]", terminal.active.toString());
                    url = "".concat(terminalsUrl, "/").concat(terminal.id, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, formData, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveTerminalSuccess(convertToTerminal(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!Axios.isCancel(apiError_7)) {
                        dispatch(error());
                        alertErrorHandler(apiError_7, dispatch, "Error saving Terminal.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchTerminalsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchTerminalsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(terminalsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchTerminalSuccess(response.data.map(function (terminalDto) { return convertToTerminal(terminalDto); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!Axios.isCancel(apiError_8)) {
                        dispatch(error());
                        alertErrorHandler(apiError_8, dispatch, "Error searching terminals.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchTerminalsOrderThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchTerminalsOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchTerminalOrderSuccess(response.data.map(function (orderDto) { return convertToTerminalOrder(orderDto); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!Axios.isCancel(apiError_9)) {
                        dispatch(error());
                        alertErrorHandler(apiError_9, dispatch, "Error searching orders.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var checkTerminalStatusThunk = function (apiClientWrapper, terminalId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(checkTerminalStatusStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(terminalUrl, "/").concat(terminalId, "/check_status?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(checkTerminalStatusSuccess(convertToTerminalStatus(terminalId, response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!Axios.isCancel(apiError_10)) {
                        dispatch(error());
                        alertErrorHandler(apiError_10, dispatch, "Error searching orders.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: TERMINALS_RESET_ACTION_TYPE,
    };
};
var getTerminalStart = function () {
    return {
        type: TERMINALS_GET_START_ACTION_TYPE,
    };
};
var getTerminalSuccess = function (terminal) {
    return {
        type: TERMINALS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            terminal: terminal
        },
    };
};
var fetchTerminalsStart = function () {
    return {
        type: TERMINALS_FETCH_START_ACTION_TYPE,
    };
};
var fetchTerminalsOrderStart = function () {
    return {
        type: TERMINALS_ORDER_FETCH_START_ACTION_TYPE,
    };
};
var saveTerminalStart = function () {
    return {
        type: TERMINALS_SAVE_START_ACTION_TYPE,
    };
};
var changeStatusOrderStart = function () {
    return {
        type: TERMINALS_CHANGE_STATUS_ORDER_START_ACTION_TYPE,
    };
};
var saveTerminalOrderStart = function () {
    return {
        type: TERMINALS_ORDER_SAVE_START_ACTION_TYPE,
    };
};
var completeTerminalOrderStart = function () {
    return {
        type: TERMINALS_ORDER_COMPLETE_START_ACTION_TYPE,
    };
};
var cancelTerminalOrderStart = function () {
    return {
        type: TERMINALS_ORDER_CANCEL_START_ACTION_TYPE,
    };
};
var deleteOrderStart = function () {
    return {
        type: TERMINALS_ORDER_DELETE_START_ACTION_TYPE,
    };
};
var fetchTerminalSuccess = function (terminals) {
    return {
        type: TERMINALS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            terminals: terminals
        },
    };
};
var fetchTerminalOrderSuccess = function (orders) {
    return {
        type: TERMINALS_ORDER_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            orders: orders
        },
    };
};
var saveTerminalSuccess = function (terminals) {
    return {
        type: TERMINALS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            terminals: terminals
        },
    };
};
var changeStatusOrderSuccess = function (order) {
    return {
        type: TERMINALS_CHANGE_STATUS_ORDER_SUCCESS_ACTION_TYPE,
        payload: {
            order: order
        },
    };
};
var cancelTerminalOrderSuccess = function (terminals) {
    return {
        type: TERMINALS_ORDER_CANCEL_SUCCESS_ACTION_TYPE,
        payload: {
            terminals: terminals
        },
    };
};
var deleteOrderSuccess = function (terminals) {
    return {
        type: TERMINALS_ORDER_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            terminals: terminals
        },
    };
};
var saveTerminalOrderSuccess = function (order) {
    return {
        type: TERMINALS_ORDER_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            order: order
        },
    };
};
var completeTerminalOrderSuccess = function (order) {
    return {
        type: TERMINALS_ORDER_COMPLETE_SUCCESS_ACTION_TYPE,
        payload: {
            order: order
        },
    };
};
var checkTerminalStatusStart = function () {
    return {
        type: TERMINALS_CHECK_STATUS_START_ACTION_TYPE,
    };
};
var checkTerminalStatusSuccess = function (terminalStatus) {
    return {
        type: TERMINALS_CHECK_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            terminalStatus: terminalStatus
        }
    };
};
var error = function () {
    return {
        type: TERMINALS_ERROR_ACTION_TYPE,
    };
};
